import { addMessages, init, getLocaleFromNavigator } from 'svelte-i18n'

import en from './i18n/en.json'

addMessages('en', en);

export default init({
  fallbackLocale: 'en',
  initialLocale: getLocaleFromNavigator(),
})